var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    stroke: "#5F788A",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6837 23.9V20.3221C10.6837 19.4121 11.4256 18.6726 12.3448 18.6665H15.7119C16.6355 18.6665 17.3842 19.4078 17.3842 20.3221V20.3221V23.9111C17.384 24.6837 18.007 25.3152 18.7872 25.3333H21.0319C23.2696 25.3333 25.0837 23.5375 25.0837 21.3221V21.3221V11.1441C25.0717 10.2726 24.6584 9.45424 23.9613 8.92187L16.2843 2.79952C14.9394 1.73349 13.0276 1.73349 11.6826 2.79952L4.03936 8.93298C3.33963 9.46319 2.92561 10.2829 2.91699 11.1553V21.3221C2.91699 23.5375 4.73101 25.3333 6.96872 25.3333H9.21345C10.0131 25.3333 10.6613 24.6916 10.6613 23.9V23.9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabHome);
export default __webpack_public_path__ + "static/media/TabHome.0810e0c0b2df261e8a8762ea8b7b64ab.svg";
export { ForwardRef as ReactComponent };